import { createContext, useContext } from 'react';
import { AthenaOneParams } from '../../utils/banner-jwt-utils';
import { IEventBus } from '../../utils/event-bus';
import { AppSettings } from '../../utils/app-settings';

export interface IWidgetContext {
  eventEmitter: IEventBus;
  controller?: string;
  provider?: string;
  factorType?: string;
  athenaOneParams?: AthenaOneParams;
  athenaOneWebSessionTimedOut?: boolean;
  athenaOneWebSso?: boolean;
  settings: AppSettings;
}

const WidgetContext = createContext<IWidgetContext | null>(null);

export const useWidgetContext = () => useContext(WidgetContext) as IWidgetContext;

export default WidgetContext;
